import api from './api';

export const verifySportsAppointment = async (appointmentId, verificationCode) => {
    return api.post('/sports/verify', { appointmentId, verificationCode });
};
